import React, { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { TSignalCountsOnSpeedRangesItem } from '../../../kpiTypes';
import { ChartContainer } from '../../../../../shared/components/charts/ChartContainer';

export interface ILoadedConditionSpeedDistributionChartProps {
	chartKey: number;
	signalCountsOnSpeedRangesData: TSignalCountsOnSpeedRangesItem[];
}

const LoadedConditionSpeedDistributionChart: React.FC<ILoadedConditionSpeedDistributionChartProps> = ({ ...props }) => {
	const data = props.signalCountsOnSpeedRangesData.map((item) => ({ ...item, countOfBallast: item.countOfBallast || null }));
	const [options] = useState<AgChartOptions>({
		data: data,
		series: [
			{
				type: 'bar',
				xKey: 'rangeLevel',
				yKey: 'countOfLaden',
				yName: 'Laden',
				fill: '#183d57',
				stroke: 'white',
				strokeWidth: 1,
			},
			{
				type: 'line',
				xKey: 'rangeLevel',
				yKey: 'countOfBallast',
				yName: 'Ballast',
				stroke: '#f0d035', // Set the line color here
				strokeWidth: 2,
				marker: {
					fill: '#f0d035',
				},
			},
		],
		axes: [
			{
				type: 'number',

				title: {
					text: '#Hours',
				},
			},
			{
				type: 'number',

				title: {
					text: 'Speed (knots)',
				},
			},
		],
		legend: {
			position: 'top',
		},
	});

	return (
		<ChartContainer
			data={options.data}
			filename="loaded_condition_speed_distribution_data"
			buttonPosition="top-right"
		>
			<AgCharts key={props.chartKey} options={options} style={{ display: 'grid', width: '100%', height: '100%' }} />
		</ChartContainer>
	);
};

export default LoadedConditionSpeedDistributionChart;
